export class BaseUserModel {
  userId: number = 0;
  companyId: number = 0;
  fullName: string = '';
  profileImgUrl: string = '';
  displayName: string = '';
  roles: Userroles[] = [];
}

export class UserModel {
  id: number = 0;
  firstName: string = '';
  middleName: string | null = null;
  lastName: string = '';
  fullName: string = '';
  email: string = '';
  phoneNumber: string | null = null;
  companyId: number = 0;
  company: any;
  userRoles: any;
  displayName: string = '';
  username: string = '';
  jobTitle: string = '';
  hireDate: Date = new Date();
  lastLogoutAt: Date = new Date();
  defaultGoalGroupId: number = 0;
  defaultGoalTypeId: number = 0;
  defaultLanguageId: number = 0;
  defaultModuleId: number = 0;
  defaultWarehouseId: number = 0;
  listerDefaultWarehouseLocationId: number | null = null;
  defaultStoreId: number = 0;
  defaultStoreLocationId: number = 0;
  productionAutoPrint: boolean = false;
  twoFactorEnabled: boolean = true;
  productionStayScreen: boolean = false;
  apps: any;
  tpmRoleId: number = 0;
  posRoleId: number = 0;
  listerRoleId: number = 0;
  donationRoleId: number = 0;
  roleId: number = 0;
  mustChangePasswordOnLogin: boolean = true;
  status: number = 1;
  invitationStatus: number = 1;
  isDisabled: boolean = false;
  posStoreIds: Number[] = [];
  profileFileUrl: string = '';
  emailConfirmed: boolean = true;
  phoneNumberConfirmed: boolean = true;
  lockoutEnd: Date = new Date();
  lockoutEnabled: boolean = true;
  accessFailedCount: number = 1;
  defaultPosStoreId: number = 0;
  lastLoginAt: Date = new Date();
  isTpmPresent: boolean = false;
  isPosPresent: boolean = false;
  isDonationPresent: boolean = false;
  isCompanyPresent: boolean = false;
}

export class Userroles {
  string: string = '';
}

export class UserRolesModel {
  id: number = 0;
  name: string = '';
  appId: number = 0;
  permissions: UserPermissionsModel[] = [];
}

export class UserPermissionsModel {
  id: number = 0;
  name: string = '';
}
